export const handleSpeechSynthesis = (text, onEndCallback) => {
    // Cancel any ongoing speech
    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);

    // Get available voices
    const voices = window.speechSynthesis.getVoices();

    // Try to find "Kore" voice, or fallback to a high-quality one
    // User specifically mentioned "Kore", checking for that name
    const koreVoice = voices.find(voice => voice.name.includes("Kore") || voice.name.includes("kore"));

    // If "Kore" not found, try to find a Hindi voice (since content seems to be Hindi/Indian context) or a Google voice
    const fallbackVoice = voices.find(voice => voice.lang.includes('hi') || voice.name.includes('Google Hindi')) ||
        voices.find(voice => voice.name.includes('Google')) ||
        voices[0];

    if (koreVoice) {
        utterance.voice = koreVoice;
    } else if (fallbackVoice) {
        utterance.voice = fallbackVoice;
    }

    // Adjust rate and pitch if needed (defaulting to normal for now)
    utterance.rate = 1;
    utterance.pitch = 1;

    utterance.onend = () => {
        if (onEndCallback) onEndCallback();
    };

    utterance.onerror = (event) => {
        console.error("SpeechSynthesis error:", event);
        if (onEndCallback) onEndCallback();
    };

    window.speechSynthesis.speak(utterance);

    return utterance; // Return the utterance in case we need to control it later
};

// Helper to ensure voices are loaded (needed for Chrome sometimes)
export const initVoices = () => {
    return new Promise((resolve) => {
        let voices = window.speechSynthesis.getVoices();
        if (voices.length > 0) {
            resolve(voices);
            return;
        }

        window.speechSynthesis.onvoiceschanged = () => {
            voices = window.speechSynthesis.getVoices();
            resolve(voices);
        };
    });
};